export const BOM_OUTPUT_REQUIRED_MESSAGE = 'A BOM needs at least one Output.';
//# sourceMappingURL=bom-output-required-message.js.map